//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import {TranslateService} from '@ngx-translate/core';

export type ConsoleEncryptionEventNames = {[key: string]: string};

export function getConsoleEncryptionEventNames(translate: TranslateService): ConsoleEncryptionEventNames {
    return {
        0: translate.instant('encryption-events-viewer.event-type-names.file-used'),
        1: translate.instant('encryption-events-viewer.event-type-names.file-encrypted'),
        2: translate.instant('encryption-events-viewer.event-type-names.file-decrypted'),
        3: translate.instant('encryption-events-viewer.event-type-names.file-key-added'),
        4: translate.instant('encryption-events-viewer.event-type-names.file-key-removed'),
        5: translate.instant('encryption-events-viewer.event-type-names.file-key-used'),
        6: translate.instant('encryption-events-viewer.event-type-names.folder-encrypted'),
        7: translate.instant('encryption-events-viewer.event-type-names.folder-key-added'),
        8: translate.instant('encryption-events-viewer.event-type-names.folder-key-removed'),
        9: translate.instant('encryption-events-viewer.event-type-names.symmetric-key-fetched'),
    }
}

export enum ConsoleEncryptionEventType {
    FILE_USED = 0,
    FILE_ENCRYPTED = 1,
    FILE_DECRYPTED = 2,
    FILE_KEY_ADDED = 3,
    FILE_KEY_REMOVED = 4,
    FILE_KEY_USED = 5,
    FOLDER_ENCRYPTED = 6,
    FOLDER_KEY_ADDED = 7,
    FOLDER_KEY_REMOVED = 8,
    SYMMETRIC_KEY_FETCHED = 9,
    FOLDER_DECRYPTED = 10,
    UNKNOWN = 11
}
export type ConsoleEncryptionScopeDisplay = { 'display': string, 'value': string};
export type ConsoleEncryptionScopeNames = {[key: string]: ConsoleEncryptionScopeDisplay};

export function getConsoleEncryptionScopeNames(translate: TranslateService): ConsoleEncryptionScopeNames {
    return {
        1: {'display': translate.instant('encryption-events-viewer.key-scope.user'), 'value': 'user'},
        2: {'display': translate.instant('encryption-events-viewer.key-scope.subscription'), 'value': 'subscription'},
        3: {'display': translate.instant('encryption-events-viewer.key-scope.recovery'), 'value': 'recovery'},
        4: {'display': translate.instant('encryption-events-viewer.key-scope.shared'), 'value': 'shared'},
    }
}

export enum ConsoleEncryptionScopeType {
    SCOPE_USER = 'user',
    SCOPE_SUB = 'subscription',
    SCOPE_RECOVERY = 'recovery',
    SCOPE_SHARED = 'shared'
}

export interface EncryptionEvent {
    dttm: string;
    clientDttm: string;
    email: string;
    computerName: string;
    keyName: string;
    clientId: number;
    eventType: ConsoleEncryptionEventType;
    consumer: string;
    userName: string;
    userUid: string;
    fileName: string;
    folderName: string;
    dataId: string;
    scope?: ConsoleEncryptionScopeType;
}
